<template lang="pug">
    .missing-email-sender-banner(v-if="isVisible")
        i.el-icon-fa-envelope-circle-check.fas.missing-email-sender-banner__icon
        .missing-email-sender-banner__text
            span.missing-email-sender-banner__title {{ $t('This store cannot send emails yet') }}
            span  &mdash; {{ $t('Order confirmations, invoices and status updates will fail until a sender is configured. No other store\'s sender is used in the meantime.') }}
        el-button(type="warning" size="mini" @click="goToCommunication")
            | {{ $t('Configure sender') }}
</template>

<i18n>
{
    "de": {
        "This store cannot send emails yet": "Dieser Store kann noch keine E-Mails versenden",
        "Order confirmations, invoices and status updates will fail until a sender is configured. No other store's sender is used in the meantime.": "Bestellbestätigungen, Rechnungen und Statusmeldungen schlagen fehl, bis ein Absender eingerichtet ist. Solange wird kein Absender eines anderen Stores verwendet.",
        "Configure sender": "Absender einrichten"
    }
}
</i18n>

<script>
import { useSetupStore } from '@/stores'
import router from '@/router'

export default {
    name: 'MissingEmailSenderBanner',
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        // Only where transactional mail actually matters: a shop-enabled store can
        // take an order the moment it goes live, and a satellite inherits a shop
        // that is already live.
        isVisible() {
            const cms = this.activeCms
            if (!cms || cms.can_send_email !== false) return false

            return (useSetupStore().enabledExtensions || []).includes('shop')
        },
    },
    methods: {
        goToCommunication() {
            router.push({ name: 'settings-communication', params: { id: undefined } })
        },
    },
}
</script>

<style lang="sass" scoped>
.missing-email-sender-banner
    background: #fdf6ec
    border: 1px solid #faecd8
    border-radius: 4px
    padding: 10px 16px
    margin: 0 0 25px 0
    display: flex
    align-items: center
    gap: 10px
    font-size: 13px
    line-height: 1.4
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)

    &__icon
        color: #E6A23C
        font-size: 16px
        flex-shrink: 0

    &__text
        flex: 1
        color: #B88230

    &__title
        font-weight: 600
</style>
